import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

interface DeleteRoleDialogProps {
  open: boolean;
  roleName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteRoleDialog({ open, roleName, onConfirm, onCancel }: DeleteRoleDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Удаление роли</DialogTitle>
      <DialogContent>
        <DialogContentText>{`Удалить роль «${roleName}»? Действие необратимо.`}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Отмена</Button>
        <Button color="error" variant="contained" onClick={onConfirm}>
          Удалить
        </Button>
      </DialogActions>
    </Dialog>
  );
}
